<template>
  <div>
    <div class="couponreceive" v-if="list.length>0">
      <div class="coupon-title">可领取的优惠券</div>
      <div class="coupon-weItem" v-for="(item,index) in list" :key="index">
        <span class="tag">省</span>
        <div class="weItem-back weItem-back1"></div>
        <!-- <div class="weItem-back weItem-back2" v-if="item.type == 2"></div>
        <div class="weItem-back weItem-back3" v-if="item.type == 3"></div> -->
        <div class="coupon-left">
          <span class="coupon-left-rmb">¥</span>
          <div class="coupon-left-right">
            <span class="coupon-left-right-price">{{item.couponAmount}}</span>
            <!-- <span class="coupon-left-rmb">折</span> -->
            <div class="coupon-left-right-alert" style="display: block;-webkit-transform-origin-x: 0;  -webkit-transform: scale(0.8);">
              满{{item.useTotalAmountLimit }}元可用
            </div>
          </div>
        </div>
        <div class="coupon-right coupon-right-padding">
          <div class="coupon-right-redbag" v-if="item.amountDeductType == '0'">
            商品券
          </div>
          <div class="coupon-right-redbag" v-if="item.amountDeductType == '1'">
            运费券
          </div>
          <div class="coupon-right-redbag" v-if="item.amountDeductType == '2'">
            代金券
          </div>
          <div class="coupon-right-title">{{item.chineseDesc}}</div>
          <div class="coupon-time">{{ item.couponUseStartTime }} - {{ item.couponUseEndTime }}</div>
        </div>
        <div class="getButton1" @click="getCoupon($event, item, index)">
          <span v-if="item.isReceive==2 || !item.isReceive || Number(item.userAvailableNum)>0">立即</span>
          <span v-if="item.isReceive==2 || !item.isReceive || Number(item.userAvailableNum)>0">领取</span>
          <span v-if="item.isReceive==1 && Number(item.userAvailableNum)<=0">去使用</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryCouponCenter, receiveCoupon } from "@/api/api";
export default {
  props: {
    list: {
      type: Array,
      default: null
    },
    isList: {
      type: Boolean,
      default: false
    },
    isPromotion: {
        type: Boolean,
        default: false
    }
  },
  watch:{
    isList:function(indexVal, oldVal){
      this.isList=indexVal
    }
  },
  data() {
    return {

    };
  },
  methods: {
    getCoupon(e, item, index){
      this.$emit("click",e, item, index);
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-title{
  font-size: 30px;
  font-weight: 600;
  margin-top: 60px;
  margin-bottom: 30px;
}
.tag{
  background: $theme-color-main;
  color: #ffffff;
  padding: 1px 5px;
  position: absolute;
  top: 0;
  left: 0;
}
  .coupon-weList {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .coupon-weItem {
    width: 692px;
    height: 174px;
    margin-bottom: 24px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .coupon-godItem {
    width: 618px;
    height: 157px;
    margin-bottom: 24px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .coupon-left-rmb {
    font-size: 41px;
    color: #fff;
  }

  .weItem-back {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .weItem-back1 {
    background-image: url("../../assets/images/coupon_we1.png");
  }

  .weItem-back2 {
    background-image: url("../../assets/images/coupon_we2.png");
  }

  .weItem-back3 {
    background-image: url("../../assets/images/coupon_we3.png");
  }

  .weItem-back4 {
    background-image: url("../../assets/images/coupon_god.png");
  }

  .coupon-left {
    display: flex;
    flex: 1;
    flex-direction: row;
    z-index: 1;
    height: 100%;
    align-items: center;
    justify-content: flex-end;
  }

  .coupon-right-padding {
    padding-left: 20px;
    padding-top: 20px;
  }

  .coupon-right {
    flex: 1;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    color: #fff;
    .coupon-right-redbag {
      height: 36px;
      width: 118px;
      background-color: #fab210;
      border-radius: 13px;
      line-height: 36px;
      text-align: center;
      font-size: 28px;
      color: #fff;
    }
    .coupon-right-title {
      height: auto;
      margin-top: 10px;
      width: 170px;
    }
    .coupon-time {
      transform: scale(0.8);
      margin-left: -28px;
    }
  }

  .coupon-left-right {
    display: flex;
    flex-direction: column;
    width: 190px;
    align-items: center;
    .coupon-left-right-price {
      font-size: 98px;
      color: #fff;
      line-height: 90px;
    }
    .coupon-left-right-alert {
      width: 171px;
      font-size: 17px;
      color: #fff;
      border: 1px solid #fff;
      text-align: center;
      border-radius: 6px;
      height: 32px;
      margin-left: 46px;
      margin-bottom: 10px;
    }
  }

  .my-coupon {
    padding-right: 40px;
    height: 106px;
    line-height: 106px;
    display: flex;
    justify-content: flex-end;
    font-size: 24px;
    text-decoration: underline;
  }

  .coupon-godList {
    width: 681px;
    height: auto;
    margin: 0 auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
    border-radius: 20px;
  }

  .god-shop {
    padding-left: 20px;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .shop-image {
    width: 50px;
    height: 50px;
    margin-left: 20px;
  }

  .shop-title {
    font-size: 28px;
    color: #333333;
    margin-left: 20px;
  }

  .getButton1 {
    width: 84px;
    height: 84px;
    background-image: radial-gradient(#fef7e7, #faba20);
    z-index: 1;
    border-radius: 50%;
    position: absolute;
    right: 5px;
    border: 4px solid $theme-color-main;
    box-shadow: 2px 2px 6px rgba($color: #000000, $alpha: 0.5);
    text-align: center;
    color: $theme-color-main;
    font-weight: bold;
    font-size: 22px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .getButton {
    width: 80px;
    height: 80px;
    background-image: radial-gradient(#fef7e7, #faba20);
    z-index: 1;
    border-radius: 50%;
    position: absolute;
    right: 3px;
    border: 4px solid $theme-color-main;
    box-shadow: 2px 2px 6px rgba($color: #000000, $alpha: 0.5);
    text-align: center;
    color: $theme-color-main;
    font-weight: bold;
    font-size: 22px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .no-coupon {
    width: 247px;
    height: 247px;
    margin: 300px auto 0;
    display: block;
  }
</style>

